<template>
  <div class="container-fluid">
    <v-toolbar dense
               src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <v-spacer></v-spacer>
      <v-btn
        class="ma-2"
        outlined
        color="error"
        @click="exportExcel"
        v-if="toolbarButtonsVisible"
      >Excel Export</v-btn>
      <v-btn
        class="ma-2"
        outlined
        color="error"
        @click="exportPdf"
        v-if="toolbarButtonsVisible"
      >PDF Export</v-btn>
    </v-toolbar>
    <v-card>
      <v-card-title>
        Dnes Vaříme
        <v-spacer></v-spacer>
        <v-menu
          ref="dayPicker"
          v-model="dayPicker"
          close-on-content-click
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Vyberte den"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" no-title scrollable first-day-of-week="1">
          </v-date-picker>
        </v-menu>
        <v-select
          :items="institutions"
          v-model="selectedInstitutionId"
          label="Filtr instituce"
          item-text="name"
          item-value="id"
          small-chips
          deletable-chips
        ></v-select>
        <v-select
          :items="diets"
          v-model="selectedDietId"
          label="Filtr jídelníčku"
          item-text="name"
          item-value="id"
          small-chips
          deletable-chips
        ></v-select>
        <v-spacer></v-spacer>
        <div class="switch-label mr-2">Součet jídel</div><v-switch v-model="overviewType"></v-switch><div class="switch-label">Rozepsat jídla</div>
        <v-spacer></v-spacer>
      </v-card-title>
      <div v-if="!overviewType">
        <v-data-table
          ref="itemsTableSum"
          :headers="headers"
          :items="itemsSum"
          sort-by="internalName"
          class="elevation-1"
          :search="search"
          :items-per-page="-1"
          locale="cs"
          single-expand
          show-expand
          item-key="internalName"
          :loading="loading"
        >
          <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
            <v-icon @click="expand(true)" v-if="item.type === 'App\\Menu' && !isExpanded">mdi-chevron-down</v-icon>
            <v-icon @click="expand(false)" v-if="item.type === 'App\\Menu' && isExpanded">mdi-chevron-up</v-icon>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Součet jídel</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Vyhledávání"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="getItems">Reset</v-btn>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" v-if="item.type === 'App\\Menu'">
              <div v-for="(menuItem, index) in item.foods.concat(item.drinks)" :key="index">
                {{menuItem.name}}
              </div>
            </td>
          </template>
        </v-data-table>
      </div>
      <div v-else>
        <v-data-table
          ref="itemsTableExp"
          :headers="headers"
          :items="itemsExp"
          sort-by="internalName"
          class="elevation-1"
          :search="search"
          :items-per-page="-1"
          locale="cs"
          item-key="internalName"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Rozepsat jídla</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Vyhledávání"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="getItems">Reset</v-btn>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import ExcelJS from 'exceljs'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
export default {
  name: 'Overview',
  data: () => ({
    loading: true,
    toolbarButtonsVisible: false,
    search: '',
    date: new Date().toISOString().substr(0, 10),
    institutions: [],
    selectedInstitutionId: null,
    diets: [],
    selectedDietId: null,
    dayPicker: false,
    headers: [
      {
        text: 'Interní název',
        align: 'start',
        sortable: true,
        value: 'internalName'
      },
      { text: 'Název jídla', value: 'name' },
      { text: 'Množství', value: 'quantity' },
      { text: 'Typ stravy', value: 'typesStr' },
      { text: 'Denní doba', value: 'timesStr' },
      { text: 'Alergeny', value: 'alergensStr' },
      { text: 'Cena', value: 'price' },
      { text: 'Objem', value: 'volume' },
      { text: 'Hmotnost', value: 'weight' },
      { text: 'Kalorie', value: 'calories' }
    ],
    overviewType: false,
    menu: [],
    itemsAll: []
  }),
  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.getItems()
      this.getDiets()
      this.getInstitutions()
    },
    getInstitutions () {
      this.$http.get('/admin/institutions')
        .then(response => {
          this.institutions = this.keysToCamelCase(response.data)
        })
    },
    getDiets () {
      this.$http.get('/admin/diets', { params: { slim: 1 } })
        .then(response => {
          this.diets = this.keysToCamelCase(response.data)
        })
    },
    getItems () {
      this.toolbarButtonsVisible = false
      this.loading = true
      this.$http.get(`/admin/overview/cook/${this.date}`)
        .then(response => {
          this.itemsAll = this.keysToCamelCase(response.data).map(item => {
            item.timesStr = item.timeTypes
              .map(time => time.name)
              .join(', ')
            item.typesStr = item.foodTypes
              .map(type => type.name)
              .join(', ')
            item.alergensStr = item.alergens
              .map(alergen => alergen.name)
              .join(', ')

            item.weight = item.weight || '—'
            item.volume = item.volume || '—'
            return item
          })

          this.loading = false
          this.toolbarButtonsVisible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    countOccurrences (arr) {
      const sorted = arr.sort((a, b) => a.id - b.id)
      const items = []; let prevId

      for (let i = 0; i < sorted.length; i++) {
        if (sorted[i].id !== prevId) {
          items.push({ ...sorted[i] })
        } else {
          items[items.length - 1].quantity += +sorted[i].quantity
        }
        prevId = sorted[i].id
      }
      return items
    },
    exportExcel () {
      const itemsToExport = this.overviewType ? this.itemsExpOrdered : this.itemsSumOrdered
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Dnes vaříme')
      sheet.mergeCells('A1:C1')
      sheet.getCell('A1').value = `Dnes vaříme – ${this.overviewType ? 'rozepsat jídla' : 'součet jídel'}`

      const now = new Date()
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      sheet.mergeCells('A2:C2')
      sheet.getCell('A2').value = `${nowCzDate} ${nowCzTime}`

      sheet.getRow(4).values = [
        'Interní název',
        'Název jídla',
        'Množství',
        'Typ stravy',
        'Denní doba',
        'Alergeny',
        'Cena',
        'Objem',
        'Hmotnost',
        'Kalorie'
      ]

      sheet.columns = [
        { key: 'internalName', width: 20 },
        { key: 'name', width: 40 },
        { key: 'quantity', width: 10 },
        { key: 'typesStr', width: 40 },
        { key: 'timesStr', width: 40 },
        { key: 'alergensStr', width: 40 },
        { key: 'price', width: 10 },
        { key: 'volume', width: 10 },
        { key: 'weight', width: 10 },
        { key: 'calories', width: 10 }
      ]
      itemsToExport.forEach((item, index) => {
        sheet.getRow(5 + index).values = {
          ...item
        }
        sheet.getRow(5 + index).height = sheet.properties.defaultRowHeight * 2
      })
      sheet.eachRow(row => {
        row.eachCell(cell => {
          cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true }
        })
      })
      workbook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = `export_dnes_varime_${this.overviewType ? 'rozepsat' : 'soucet'}.xlsx`
        anchor.click()
        window.URL.revokeObjectURL(url)
      })
    },
    exportPdf () {
      const exportType = this.overviewType
      const now = new Date()
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      const itemsToExport = this.overviewType ? this.itemsExpOrdered : this.itemsSumOrdered
      const tableItems = itemsToExport.map(item => [
        item.internalName,
        item.name,
        item.quantity,
        item.typesStr,
        item.timesStr,
        item.alergensStr,
        item.price,
        item.volume,
        item.weight,
        item.calories
      ])
      pdfMake.vfs = pdfFonts.pdfMake.vfs
      const docDefinition = {
        pageOrientation: 'landscape',
        content: [
          {
            text: `Dnes vaříme – ${exportType ? 'rozepsat jídla' : 'součet jídel'}`
          },
          {
            text: `${nowCzDate} ${nowCzTime}`
          },
          {
            table: {
              body: [
                [
                  'Interní název',
                  'Název jídla',
                  'Množství',
                  'Typ stravy',
                  'Denní doba',
                  'Alergeny',
                  'Cena',
                  'Objem',
                  'Hmotnost',
                  'Kalorie'
                ],
                ...tableItems
              ]
            }
          }
        ]
      }
      pdfMake.createPdf(docDefinition).download(`export_dnes_varime_${exportType ? 'rozepsat' : 'soucet'}`)
    }
  },
  watch: {
    date () {
      this.getItems()
    }
  },
  computed: {
    drinks () {
      let drinks = this.itemsAll
        .filter(item => item.type === 'App\\Drink') // drinks
        .filter(item => this.selectedInstitutionId ? item.institutionId === this.selectedInstitutionId : true) // institutions
        .filter(item => this.selectedDietId ? item.dietId === this.selectedDietId : true) // diets
        .sort((a, b) => a.id - b.id)

      drinks = this.countOccurrences(drinks)
      return drinks
    },
    foods () {
      let foods = this.itemsAll
        .filter(item => item.type === 'App\\Food') // foods
        .filter(item => this.selectedInstitutionId ? item.institutionId === this.selectedInstitutionId : true) // institutions
        .filter(item => this.selectedDietId ? item.dietId === this.selectedDietId : true) // diets
        .sort((a, b) => a.id - b.id)

      foods = this.countOccurrences(foods)
      return foods
    },
    menus () {
      let menus = this.itemsAll
        .filter(item => item.type === 'App\\Menu') // menus
        .filter(item => this.selectedInstitutionId ? item.institutionId === this.selectedInstitutionId : true) // institutions
        .filter(item => this.selectedDietId ? item.dietId === this.selectedDietId : true) // diets
        .map(menu => {
          menu.volume = menu.drinks
            .map(drink => drink.volume)
            .reduce((total, current) => total + +current, 0)
          return menu
        })
        .sort((a, b) => a.id - b.id)

      menus = this.countOccurrences(menus)
      return menus
    },
    menuDrinks () {
      const result = []
      this.menus.forEach(menu => {
        menu.drinks
          .map(drink => {
            drink.weight = '—'
            drink.timesStr = drink.timeTypes
              .map(time => time.name)
              .join(', ')
            drink.typesStr = drink.foodTypes
              .map(type => type.name)
              .join(', ')
            drink.alergensStr = drink.alergens
              .map(alergen => alergen.name)
              .join(', ')
            return drink
          })
          .forEach(drink => {
            drink.quantity = menu.quantity
            result.push(drink)
          })
      })

      return result
    },
    menuFoods () {
      const result = []
      this.menus.forEach(menu => {
        menu.foods
          .map(food => {
            food.volume = '—'
            food.timesStr = food.timeTypes
              .map(time => time.name)
              .join(', ')
            food.typesStr = food.foodTypes
              .map(type => type.name)
              .join(', ')
            food.alergensStr = food.alergens
              .map(alergen => alergen.name)
              .join(', ')
            return food
          })
          .forEach(food => {
            food.quantity = menu.quantity
            result.push(food)
          })
      })

      return result
    },
    itemsSum () {
      return this.drinks.concat(this.foods, this.menus)
    },
    itemsExp () {
      const drinks = this.countOccurrences(this.drinks.concat(this.menuDrinks))
      const foods = this.countOccurrences(this.foods.concat(this.menuFoods))

      return drinks.concat(foods)
    },
    itemsSumOrdered () {
      return this.$refs.itemsTableSum.selectableItems
    },
    itemsExpOrdered () {
      return this.$refs.itemsTableExp.selectableItems
    }
  }
}
</script>

<style scoped>

</style>
